import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Toolbar,
  AppBar,
  Menu,
  MenuItem,
  Avatar,
  CircularProgress,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import logo from "../../images/tlogo.png";
import { useUserContext } from "../../context/UserContext";
import GoogleTranslateWidget from "../common/GoogleTranslate/GoogleTranslateWidget";

const Headers = ({
  setIsSidebarOpen,
  isSidebarOpen,
  menuButtonRef,
  handleMenu,
  anchorEl,
  handleClose,
  setPage,
  showMenuIcon,
} = {}) => {
  const { selectedUserDetail, avatarUrl, avatarLoading } =
    useUserContext() || {};
  const { firstName, lastName, admin } = selectedUserDetail || {};

  const initials = `${firstName ? firstName.charAt(0) : ""}${
    lastName ? lastName.charAt(0) : ""
  }`;

  const handleViewProfileClick = () => {
    setPage("profile");
    handleClose();
  };

  const handleViewDashboardClick = () => {
    setPage("dashboard");
    handleClose();
  };

  return (
    <AppBar position="fixed" sx={{ zIndex: 1300 }}>
      <Toolbar>
        {showMenuIcon && (
          <IconButton
            aria-label="open drawer"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            edge="start"
            sx={{ color: "#fff", mr: 2 }}
            ref={menuButtonRef}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mr: 2,
            mt: 1,
            cursor: "pointer",
          }}
          onClick={handleViewDashboardClick}
        >
          <img
            src={logo}
            alt="Toyota Logo"
            style={{ width: "50px", height: "40px" }}
          />
          <Typography
            variant="p"
            noWrap
            component="p"
            sx={{
              color: "#ffffff",
              textDecoration: "none",
              letterSpacing: "0rem",
              fontSize: "0.8rem",
              textAlign: "center",
              mb: 1,
            }}
          >
            Global TreasuryFin Suite
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: "flex", alignItems: "center", mr: 2 }}>
          <GoogleTranslateWidget />
        </Box>
        <Typography variant="p" sx={{ ml: 1 }}>
          Welcome, {firstName} {lastName}{" "}
          {admin && (
            <StarIcon
              sx={{
                fontSize: "22px",
                marginRight: "15px",
                marginBottom: "-6px",
                color: "#ffd600",
              }}
            />
          )}
        </Typography>
        <div>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            <Avatar src={avatarUrl} sx={{ width: 40, height: 40 }}>
              {avatarLoading ? (
                <CircularProgress color="inherit" />
              ) : avatarUrl ? (
                initials
              ) : (
                <AccountCircleIcon sx={{ fontSize: 40 }} />
              )}
            </Avatar>
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleViewDashboardClick}>Dashboard</MenuItem>
            <MenuItem onClick={handleViewProfileClick}>Profile</MenuItem>
            {/* <MenuItem onClick={handleLogoutClick}>Logout</MenuItem> */}
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Headers;
